import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { TOKEN_KEY } from './api';

/** /b/:token — stash the token, then keep it out of the address bar. */
export function BriefingTokenEntry() {
  const { token } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    void navigate('/b', { replace: true });
  }, [token, navigate]);
  return null;
}
